import { render, staticRenderFns } from "./trashrightclick.vue?vue&type=template&id=0ec614ca&"
import script from "./trashrightclick.vue?vue&type=script&lang=js&"
export * from "./trashrightclick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports